import { render } from "./ShowListAlt.vue?vue&type=template&id=42042815"
import script from "./ShowListAlt.vue?vue&type=script&lang=js"
export * from "./ShowListAlt.vue?vue&type=script&lang=js"
script.render = render

export default script